import React from "react";
import PropTypes from "prop-types";

import isMobile from "utils/isMobileDevice";

import styles from "./Dropzone.css";

const ImagePreview = ({ url }) =>
  isMobile() ? (
    <img alt="" className={styles.fillMobile} src={url} />
  ) : (
    <div className={styles.fill} style={{ backgroundImage: `url('${url}')` }} />
  );

ImagePreview.propTypes = {
  url: PropTypes.string.isRequired,
};

export default ImagePreview;
